import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'booking.payment.title',
    defaultMessage: 'Your booking',
  },
});
